export function getSlider(state) {
  return state.slider;
}






